import { render, staticRenderFns } from "./OrderFlagButton.vue?vue&type=template&id=5a2d9f54"
import script from "./OrderFlagButton.vue?vue&type=script&lang=js"
export * from "./OrderFlagButton.vue?vue&type=script&lang=js"
import style0 from "./OrderFlagButton.vue?vue&type=style&index=0&id=5a2d9f54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports